import { configureStore } from "@reduxjs/toolkit";
import { baseAPI } from "../api/api";
import KPIDepotsReducer from "./slices/KPIDepotsSlice";
import alertsListReducer from "./slices/alertsList";
import authReducer from "./slices/authSlice";
import biiSortDatesSliceReducer from "./slices/biiSortDatesSlice";
import depotsReducer from "./slices/depotsSlice";
import ebmTrainingStatusReducer from "./slices/ebm-training-status";
import isLayoutTallReducer from "./slices/layoutSlice";
import momoPaymentStatusReducer from "./slices/momo-payment-status";
import orderFiltersReducer from "./slices/orderFilters";
import paginatedDataReducer from "./slices/paginatedData";
import salesFiltersReducer from "./slices/salesFilters";
import searchStakeholdersReducer from "./slices/searchStakeholdersSlice";
import selectedQBCategoriesReducer from "./slices/selectedQBCategories";
import sortDatesReducer from "./slices/sortDatesSlice";
import topUpFiltersReducer from "./slices/topUpFilters";
import trainingResponsesFiltersReducer from "./slices/trainingResponsesFilters";
import truckMisuseFiltersReducer from "./slices/truckMisuseFilters";
import trucksReducer from "./slices/trucksSlice";
import warehouseCategoryFilterReducer from "./slices/warehouseCategoryFilter";

/**
 * @author Kundwa Bruno M <kundwabruno@gmail.com>
 * @since July 2022
 */

export const store = configureStore({
  reducer: {
    [baseAPI.reducerPath]: baseAPI.reducer,
    auth: authReducer,
    trucks: trucksReducer,
    depots: depotsReducer,
    paginatedData: paginatedDataReducer,
    sortDates: sortDatesReducer,
    kpiDepots: KPIDepotsReducer,
    selectedQBCategories: selectedQBCategoriesReducer,
    alertsList: alertsListReducer,
    momoPaymentStatus: momoPaymentStatusReducer,
    isLayoutTall: isLayoutTallReducer,
    orderFilters: orderFiltersReducer,
    salesFilters: salesFiltersReducer,
    biiSortDates: biiSortDatesSliceReducer,
    stakeholdersSearch: searchStakeholdersReducer,
    warehouseCategoryFilter: warehouseCategoryFilterReducer,
    ebmTrainingStatus: ebmTrainingStatusReducer,
    truckMisuseFilters: truckMisuseFiltersReducer,
    trainingResponsesFilters: trainingResponsesFiltersReducer,
    topUpFilters: topUpFiltersReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseAPI.middleware)
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
